import { HintAnimation } from '../hint-motion';
import { hline, pill, text } from '../../academy/films/story-scene';
import { abs, C, DIVIDER_H, glass, icon, orbiTemplate, PRESSED } from './scene-kit';
import { CONTENT, HintStory, inputField, outlinePill, portalShell } from './hint-story';

/**
 * Hinweis H „Lade dein Team ein“.
 *
 * Didaktik: Allein eingerichtet, bleibt ein Agent die Sache einer Person —
 * mit Kolleginnen und Kollegen wird er Teil der Lehre. WARUM „Arbeite im
 * Team — lade Kolleginnen und Kollegen ein“ → WO Avatar oben rechts ›
 * Organisation (derselbe Weg wie zum Produktplan in Hinweis 4) → WAS
 * „Hinzufügen“, Name, E-Mail, Rolle, „Speichern“ → GESCHAFFT die neue
 * Person steht als „Eingeladen“ in der Liste, Orbi lacht. Die Rolle steht
 * sichtbar im Dialog: wer einlädt, entscheidet, was die Person darf.
 */

const AV: [number, number] = [597, 31];
const MENU = { x: 476, y: 52, w: 150, row: 28, pad: 6 };
const MENU_ITEMS: [string, string][] = [['card', 'Produktplan'], ['users', 'Organisation'], ['gear', 'Einstellungen'], ['logout', 'Abmelden']];
const MENU_Y = (i: number) => MENU.pad + i * MENU.row + (i === 3 ? 6 : 0);
const ORG: [number, number] = [MENU.x + 66, MENU.y + MENU_Y(1) + 13];
const DLG = { x: 160, y: 84, w: 320, h: 214 };
const ADD: [number, number] = [CONTENT.x + 395, CONTENT.y + 70];
const SAVE: [number, number] = [DLG.x + 246, DLG.y + 181];

const menu =
  `<div data-r="menu" style="${abs(MENU.x, MENU.y, MENU.w, MENU.pad * 2 + MENU.row * 4 + 6, 'opacity:0;transform-origin:80% 0;')}">` +
  glass(
    18,
    0.95,
    'inset:0;',
    MENU_ITEMS.map(
      ([ic, label], i) =>
        `<div style="${abs(MENU.pad, MENU_Y(i), MENU.w - MENU.pad * 2, MENU.row - 2, 'display:flex;')}">` +
        (i === 1 ? `<div data-r="menuSel" style="position:absolute;inset:0;border-radius:999px;opacity:0;${PRESSED}"></div>` : '') +
        `<div style="position:relative;flex:1;display:flex;align-items:center;gap:8px;padding:0 10px;font-size:12px;font-weight:500;color:${C.text};white-space:nowrap;">${icon(ic, 14)}${label}</div></div>`,
    ).join('') + `<div style="${abs(MENU.pad + 8, MENU_Y(3) - 4, MENU.w - MENU.pad * 2 - 16, 2, `background:${DIVIDER_H};`)}"></div>`,
  ) +
  `</div>`;

const agentsPage = `<div data-r="pageA">` + text(20, 12, 300, 'KI-Agenten', 18, 400) + hline(16, 46, 428) + `</div>`;

const userCard = (x: number, initials: string, name: string, mail: string, status: string, statusColor: string) =>
  glass(
    16,
    0.55,
    `left:${x}px;top:98px;width:132px;height:120px;`,
    `<div style="${abs(46, 12, 40, 40, `border-radius:999px;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:600;color:${C.text};background:radial-gradient(circle at 30% 25%, rgb(255 255 255 / .9), rgb(255 255 255 / .55) 45%, rgb(147 197 253 / .45));`)}">${initials}</div>` +
      text(6, 58, 120, name, 12.5, 600, C.text, 'text-align:center;') +
      text(6, 76, 120, mail, 10.5, 500, C.muted, 'text-align:center;') +
      text(6, 94, 120, status, 10.5, 600, statusColor, 'text-align:center;'),
  );

const orgPage =
  `<div data-r="pageB" style="opacity:0;">` +
  text(20, 12, 200, 'Organisation', 18, 400) +
  hline(16, 46, 428) +
  `<div style="${abs(20, 60, 200, 22, `display:flex;align-items:center;gap:7px;font-size:13px;font-weight:500;color:${C.text};`)}">${icon('users', 16, C.accent)}Benutzer</div>` +
  outlinePill(346, 55, 98, 'Hinzufügen') +
  `<div data-r="addGlow" style="${abs(346, 55, 98, 30, 'border-radius:999px;')}"></div>` +
  userCard(20, 'AW', 'Alex Weber', 'alex@hochschule.de', 'Admin', C.muted) +
  `<div data-r="card2" style="opacity:0;transform-origin:230px 158px;">` +
  userCard(164, 'JK', 'Jana Klein', 'jana@hochschule.de', 'Eingeladen', C.okInk) +
  `<div style="${abs(270, 104, 22, 22)}">${orbiTemplate('inv', 22)}</div>` +
  `</div>` +
  `</div>`;

const label = (x: number, y: number, s: string) => text(x, y, 200, s, 11, 700, C.muted);

const dialog =
  `<div data-r="dlg" style="opacity:0;transform-origin:${DLG.x + DLG.w / 2}px ${DLG.y + DLG.h / 2}px;">` +
  glass(
    22,
    0.95,
    `left:${DLG.x}px;top:${DLG.y}px;width:${DLG.w}px;height:${DLG.h}px;`,
    text(18, 14, 280, 'Benutzer hinzufügen', 14, 600) +
      hline(14, 42, 292) +
      label(18, 52, 'Name') +
      inputField(18, 70, 284, '', 'phName', 'nm', 30) +
      label(18, 106, 'E-Mail') +
      inputField(18, 124, 284, '', 'phMail', 'em', 30) +
      `<div style="${abs(18, 166, 140, 30, `border-radius:999px;background:rgb(255 255 255 / .6);display:flex;align-items:center;justify-content:space-between;padding:0 12px;box-sizing:border-box;font-size:12px;color:${C.text};`)}"><span><span style="color:${C.muted};">Rolle: </span><b style="font-weight:600;">Manager</b></span>${icon('chevron', 12)}</div>` +
      pill(190, 165, 112, 'Speichern'),
  ) +
  `</div>`;

export const inviteTeamAnimation = (): HintAnimation =>
  new HintStory({
    intro: { line1: ['Arbeite', 'im', 'Team'], line2: ['lade', 'Kolleginnen', 'und', 'Kollegen', 'ein'] },
    portal: portalShell({ active: 0, content: agentsPage + orgPage }) + menu + dialog,
    tracks: [
      { r: 'menu', at: [1.42, 1.56, 1.86, 1.98], o: [0, 1, 1, 0], y: [-6, 0, 0, 0] },
      { r: 'menuSel', at: [1.8, 1.88], o: [0, 1] },
      { r: 'nav0', at: [1.9, 2.0], o: [1, 0] },
      { r: 'pageA', at: [1.9, 2.0], o: [1, 0] },
      { r: 'pageB', at: [1.98, 2.16], o: [0, 1], y: [8, 0] },
      { r: 'dlg', at: [2.36, 2.52, 3.2, 3.32], o: [0, 1, 1, 0], s: [0.96, 1, 1, 0.98] },
      { r: 'card2', at: [3.32, 3.52], o: [0, 1], s: [0.85, 1] },
    ],
    typing: [
      { r: 'nm', text: 'Jana Klein', from: 2.54, to: 2.74 },
      { r: 'em', text: 'jana@hochschule.de', from: 2.78, to: 3.02 },
    ],
    glows: [
      { r: 'avatar', at: 1.05, dur: 0.4 },
      { r: 'addGlow', at: 2.05, dur: 0.35 },
    ],
    orbis: [{ prefix: 'inv', pop: 3.46, laugh: 3.58 }],
    cursor: {
      at: [0, 1.0, 1.32, 1.44, 1.72, 1.84, 2.18, 2.3, 3.0, 3.12, 3.7, 99],
      x: [300, 300, AV[0], AV[0], ORG[0], ORG[0], ADD[0], ADD[0], SAVE[0], SAVE[0], 520, 520],
      y: [250, 250, AV[1], AV[1], ORG[1], ORG[1], ADD[1], ADD[1], SAVE[1], SAVE[1], 330, 330],
      clicks: [1.38, 1.8, 2.26, 3.08],
    },
    camera: {
      at: [0, 2.38, 2.6, 3.2, 3.45, 99],
      x: [320, 320, 320, 320, 330, 330],
      y: [176, 176, 191, 191, 180, 180],
      s: [1, 1, 1.25, 1.25, 1.12, 1.12],
    },
    still: 3.95,
  });
